import React from "react";
import io from "socket.io-client";
import { SOCKET_URL_ENDPOINT } from "../config/Constant";

const SocketContext = React.createContext();

const SocketProvider = ({ children }) => {
  const socket = io(SOCKET_URL_ENDPOINT, { transports: ["polling"] });
  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export { SocketContext, SocketProvider };
